import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { logoutUser } from "../../store/actions";
//redux
import { useDispatch, useSelector } from "react-redux";
import loadingAD from "../../assets/json/load-fragmented-square.json"
import Lottie from 'lottie-react';
import {
  Row,
  Col ,
  Container
} from "reactstrap"
const Logout = props => {
  const dispatch = useDispatch()
  useEffect(() => {
    document.getElementById("body").className = "body"
  }, [])
  useEffect(() => {
    dispatch(logoutUser(props.history))
  }, [dispatch])
  const { loading } = useSelector(state => ({
    loading: state.Login.loading
  }));
  
  return (
    loading ? (
      <Container fluid={true}>

      <Row>
        <Col md={4}></Col>
         
         <Col md={8}>
        <Lottie animationData={loadingAD} loop={true} />
      </Col></Row >
      </Container>
    ) : (<></>))
}

Logout.propTypes = {
  history: PropTypes.object,
}

export default withRouter(Logout)
